import React from "react";
import "./AirlineStrip.css";

const airlines = [
  { name: "Emirates", code: "EK" },
  { name: "British Airways", code: "BA" },
  { name: "Lufthansa", code: "LH" },
  { name: "Qatar Airways", code: "QR" },
  { name: "Turkish Airlines", code: "TK" },
  { name: "Air France", code: "AF" },
  { name: "KLM", code: "KL" },
  { name: "Etihad", code: "EY" },
  { name: "Singapore Airlines", code: "SQ" },
  { name: "Ryanair", code: "FR" },
  { name: "easyJet", code: "U2" },
  { name: "Wizz Air", code: "W6" },
];

const ticker = [...airlines, ...airlines];

const getAirlineLogoUrl = (code) =>
  code ? `https://www.gstatic.com/flights/airline_logos/70px/${code}.png` : null;

const AirlineLogo = ({ name, code }) => {
  const src = getAirlineLogoUrl(code);

  return (
    <>
      {src ? (
        <img
          src={src}
          alt={`${name} logo`}
          onError={(e) => {
            e.currentTarget.style.display = "none";
            const fallback = e.currentTarget.nextElementSibling;
            if (fallback) fallback.style.display = "inline";
          }}
        />
      ) : null}
      <span className="airline-strip-fallback" style={{ display: src ? "none" : "inline" }}>
        {name}
      </span>
    </>
  );
};

const AirlineStrip = () => {
  return (
    <section className="airline-strip">
      <div className="airline-strip-header">
        <p>Flights available with 200+ airlines worldwide</p>
      </div>

      <div className="airline-strip-track-wrap">
        <div className="airline-strip-track">
          {ticker.map((airline, i) => (
            <div key={`${airline.code}-${i}`} className="airline-strip-item">
              <AirlineLogo name={airline.name} code={airline.code} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AirlineStrip;
